(()=>{
const q=(r,s)=>[...r.querySelectorAll(s)];
const mq=matchMedia('(max-width: 767px)');
function swipe(el,prev,next){let x0=null;el.addEventListener('pointerdown',e=>{x0=e.clientX});el.addEventListener('pointerup',e=>{if(x0===null)return;const d=e.clientX-x0;x0=null;if(Math.abs(d)>40)(d<0?next:prev)()})}
q(document,'.pn [data-pn-cards]').forEach(b=>{
  q(b,'.pn-l').forEach(l=>{
    const win=l.querySelector('.pn-win');if(!win)return;
    const vis=+win.dataset.pnCar,track=win.querySelector('.pn-track'),cards=q(track,'.pn-card'),max=Math.max(0,cards.length-vis);
    const dots=l.querySelector('.pn-dots');let i=0;
    if(dots){cards.forEach((c,k)=>{const d=document.createElement('button');d.type='button';d.setAttribute('role','tab');d.setAttribute('aria-label','Producto '+(k+1));d.onclick=()=>go(k);dots.appendChild(d)})}
    function go(n){i=n<0?max:n>max?0:n;const c=cards[0];const g=parseFloat(getComputedStyle(track).columnGap)||0;track.style.transform='translateX('+(-i*(c.getBoundingClientRect().width+g))+'px)';if(dots)q(dots,'button').forEach((d,k)=>d.setAttribute('aria-selected',k===i))}
    l.querySelector('[data-pn="prev"]').onclick=()=>go(i-1);
    l.querySelector('[data-pn="next"]').onclick=()=>go(i+1);
    swipe(win,()=>go(i-1),()=>go(i+1));
    addEventListener('resize',()=>go(i));go(0);
  });
});
function slides(b,auto){
  const s=q(b,':scope>.pn-s');let i=0,t=null;
  const vis=()=>s.filter(x=>getComputedStyle(x).display!=='none');
  function go(n){const v=vis();if(v.length<2)return;i=(n+v.length)%v.length;s.forEach(x=>{const on=x===v[i];x.classList.toggle('is-on',on);x.setAttribute('aria-hidden',!on)})}
  q(b,'[data-pn="next"]').forEach(a=>a.onclick=()=>go(i+1));
  q(b,'[data-pn="prev"]').forEach(a=>a.onclick=()=>go(i-1));
  swipe(b,()=>go(i-1),()=>go(i+1));
  if(auto){const run=()=>{clearInterval(t);t=setInterval(()=>go(i+1),6000)};b.addEventListener('mouseenter',()=>clearInterval(t));b.addEventListener('mouseleave',run);run()}
  mq.addEventListener('change',()=>go(0));
}
q(document,'.pn [data-pn-fade]').forEach(b=>slides(b,true));
q(document,'.pn [data-pn-duo]').forEach(b=>slides(b,false));
})();
